import React from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "@store/useUserStore";
import { useSnackbar } from "contexts/SnackbarContext";
import "assets/scss/components/menuList.scss";

/**
 * 메뉴 목록 컴포넌트
 * @param {string} title 메뉴 제목
 * @param {{name:string, link:string}} btn 버튼 텍스트
 * @param {array} list {title: string, description: string, link: string}
 * @returns
 */
const MenuList = ({ title, btn = null, list, onItemClick }) => {
    const navigate = useNavigate();
    const userInfo = useUserStore((state) => state.userInfo);

    const { showError } = useSnackbar();

    return (
        <div className="menu-list-wrap">
            <p className="menu-title bold">
                {title}
                {btn && (
                    <span
                        className="menu-btn"
                        onClick={() => navigate(btn.link)}
                    >
                        {btn.name}
                    </span>
                )}
            </p>
            <div>
                {list.map((item, idx) => (
                    <div
                        key={idx}
                        className="menu-item"
                        onClick={() => {
                            if (onItemClick) {
                                onItemClick(item);
                            } else if (item.link) {
                                if (item.link.includes("http")) {
                                    window.open(item.link, "_blank");
                                } else {
                                    if (userInfo) {
                                        navigate(item.link);
                                    } else {
                                        showError("로그인 후 이용가능합니다.");
                                    }
                                }
                            }
                        }}
                    >
                        <p className="menu-name">
                            <span>{item.title}</span>
                            {item.description && (
                                <span
                                    style={{ marginLeft: "3px" }}
                                    className="menu-sub"
                                >
                                    {item.description}
                                </span>
                            )}
                        </p>
                        {item.link && (
                            <i className="icon icon-left-arrow-gray" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MenuList;
